import { object, string } from "yup";

export interface DiscardRenewalModalForm {
  reason: string;
}

export const discardRenewalReasonValidator = object({
  reason: string()
    .required("Reason for discarding renewal is required")
    .trim()
    .min(5, "Discard reason must be at least 5 characters")
    .max(500, "Discard reason must be at most 500 characters"),
});
